<template>
  <footer>
    <p :class="$style.attribution">
      Challenge by
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">
        Frontend Mentor
      </a>
      . Coded by <a href="https://github.com/jastenn">Justine Aviso</a>.
    </p>
  </footer>
</template>

<style module>
.attribution {
  padding-top: 3em;
  font-size: 11px;
  text-align: center;
}

.attribution a {
  color: var(--accent);
  font-weight: 700;
}
</style>
